export const ATT_TYPES = [
  { value: 'pdf', label: 'PDF' },
  { value: 'word', label: 'Word' },
  { value: 'excel', label: 'Excel' },
  { value: 'ppt', label: 'PowerPoint' },
];

export const EMPTY_FORM = {
  name: '',
  crn: '',
  address: '',
  phone: '',
  email: '',
  registeredCapital: '',
  paidInCapital: '',
  authorizedCapital: '',
  sharesCount: '',
  shareParValue: '',
  notes: '',
  status: 'active',
  isMain: false,
  contracts: [],
  newAttName: '',
  newAttType: 'pdf',
};

const SAMPLE_COMPANY_NAMES = [
  'شركة كورب باس للاستشارات الإدارية',
  'مؤسسة حلول الأعمال المتقدمة',
  'شركة أفق الاستثمار القابضة',
  'شركة نماء البناء للمقاولات',
  'شركة دراية المالية المحدودة',
  'شركة سنام التوريدات التجارية',
];

/** Realistic sample values; name + CRN get a unique tail (company name must stay unique in DB). */
export function getSampleBranchForm() {
  const n = Date.now();
  const tag = String(n).slice(-6);
  const baseName = SAMPLE_COMPANY_NAMES[n % SAMPLE_COMPANY_NAMES.length];
  const crnCore = String(1000000000 + (n % 899999999)).padStart(10, '0').slice(0, 10);
  const phone = `011${String(2000000 + (n % 7999999)).padStart(7, '0').slice(0, 7)}`;
  return {
    ...EMPTY_FORM,
    name: `${baseName} — ${tag}`,
    crn: crnCore,
    address: 'برج المملكة، طريق الملك فهد، حي العليا، الرياض 12214، المملكة العربية السعودية',
    phone,
    email: `info.${tag}@mithaq.sa`,
    registeredCapital: '5000000',
    paidInCapital: '3800000',
    authorizedCapital: '10000000',
    sharesCount: '500000',
    shareParValue: '20',
    notes: 'هيئة تأسيس جاهزة للمراجعة. يُرجى استبدال هذه الملاحظة بالوثائق الرسمية قبل اعتماد السجل.',
    status: 'active',
    contracts: [],
    newAttName: '',
    newAttType: 'pdf',
  };
}

const DEFAULT_VALIDATION_AR = {
  nameRequired: 'اسم الشركة مطلوب',
  crnRequired: 'رقم السجل التجاري مطلوب',
  addressRequired: 'العنوان مطلوب',
  phoneRequired: 'رقم الهاتف مطلوب',
  emailInvalid: 'البريد الإلكتروني غير صحيح',
};

/** @param {Record<string, string>} [messages] Override labels (e.g. English from UI). */
export function validateBranchForm(form, messages = {}) {
  const m = { ...DEFAULT_VALIDATION_AR, ...messages };
  const errors = {};
  if (!form.name.trim()) errors.name = m.nameRequired;
  if (!form.crn.trim()) errors.crn = m.crnRequired;
  if (!form.address.trim()) errors.address = m.addressRequired;
  if (!form.phone.trim()) errors.phone = m.phoneRequired;
  if (form.email && !/\S+@\S+\.\S+/.test(form.email)) errors.email = m.emailInvalid;
  return errors;
}

export function formatFileSize(bytes, lang = 'ar') {
  const isAr = lang === 'ar';
  if (bytes < 1024) return `${bytes} ${isAr ? 'بايت' : 'B'}`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} ${isAr ? 'كيلوبايت' : 'KB'}`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} ${isAr ? 'ميجابايت' : 'MB'}`;
}

export function inferTypeFromName(filename) {
  const ext = (filename.split('.').pop() || '').toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (['doc', 'docx'].includes(ext)) return 'word';
  if (['xls', 'xlsx'].includes(ext)) return 'excel';
  if (['ppt', 'pptx'].includes(ext)) return 'ppt';
  return 'pdf';
}
